import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import Button from '$partials/ui/button';
import ModuleModal from './modal';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleDuoItem = ({
    body,
    cardTitle,
    ctaLabel,
    ctaLink,
    eyebrowIcon,
    eyebrowTitle,
    image = {},
    modal,
    variant
}) => {
    return (
        <div className='flex flex-col justify-between rounded-button overflow-hidden bg-sand'>
            <div className='px-30 pt-30 pb-40 md:pt-35 md:px-40'>
                {cardTitle && (
                    <div className='flex flex-row items-center mb-8 sm:mb-18'>
                        {eyebrowIcon && (
                            <div
                                className='mr-10'
                                style={{
                                    fontSize: '18px',
                                    width: `${(eyebrowIcon?.width / eyebrowIcon?.height)}em` ,
                                    maxWidth: '100%'
                                }}>
                                <Image
                                    {...eyebrowIcon}
                                    loading={''}/>
                            </div>
                        )}
                        <p className='type-style-7 text-orange'>
                            {eyebrowTitle}
                        </p>
                    </div>
                )}
                <p className='type-style-3'>{cardTitle}</p>
                {body && (
                    <p className='mt-8 sm:mt-10 text-light-grey type-style-5'>
                        {body}
                    </p>
                )}
                {/* Variant A: Cta link & label */}
                {ctaLabel && ctaLink && variant === 'Variant A' && (
                    <div className='w-full flex mt-15 md:mt-20'>
                        <Button
                            as='a'
                            className='flex items-center self-start bg-orange text-white rounded-button type-style-7 px-20 py-15'
                            href={ctaLink}
                            type='button'>
                            {ctaLabel}
                        </Button>
                    </div>
                )}
            </div>
            <div className='relative'>
                {
                    image?.contentType === 'video/mp4' ? (
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            src={image?.src}
                            width={'100%'}/>
                    ) : (
                        <Image
                            loadWidth={979}
                            {...image}
                            style={{width: undefined}} />
                    )}
                {/* Variant B: modal */}
                {modal && variant === 'Variant B' && (
                    <div className='absolute bottom-0 left-0 m-30 md:m-40'>
                        <ModuleModal {...modal}/>
                    </div>
                )}
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleDuoItem.propTypes = {
    body: PropTypes.string,
    cardTitle: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string,
    eyebrowIcon: PropTypes.shape({
        src: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }),
    eyebrowTitle: PropTypes.string,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired
    }).isRequired,
    modal: PropTypes.object,
    variant: PropTypes.string,
};

export default ModuleDuoItem;
